export const WAEC_COMMERCE = [
  {
    q: "Trade that occurs between countries is called:",
    o: ["Home trade", "Entrepot trade", "International trade", "Retail trade"],
    a: 2,
    e: "International trade (foreign trade) involves the exchange of goods and services between different countries.",
    h: "Crosses national borders.",
    yr: "2023",
  },
  {
    q: "A wholesaler buys goods from:",
    o: ["Retailers", "Consumers", "Manufacturers", "Government"],
    a: 2,
    e: "Wholesalers buy in bulk from manufacturers or producers, then sell in smaller quantities to retailers.",
    h: "Middle of the distribution chain.",
    yr: "2022",
  },
  {
    q: "Insurance is based on the principle of:",
    o: ["Profit maximisation", "Indemnity", "Speculation", "Barter"],
    a: 1,
    e: "The principle of indemnity ensures that the insured is restored to their original financial position after a loss, no more.",
    h: "You shouldn't profit from insurance.",
    yr: "2023",
  },
  {
    q: "A bill of lading is used in:",
    o: ["Banking", "Road transport", "Sea transport", "Air transport"],
    a: 2,
    e: "A bill of lading is a legal document in sea transport, issued by the shipping company as a receipt for goods.",
    h: "Shipping document.",
    yr: "2021",
  },
  {
    q: "Advertising that aims to increase general demand for a product category is called:",
    o: ["Selective advertising", "Competitive advertising", "Persuasive advertising", "Generic advertising"],
    a: 3,
    e: "Generic advertising promotes a product category rather than a specific brand (e.g. 'Drink more milk').",
    h: "Not for a specific brand.",
    yr: "2022",
  },
];

export const WAEC_COMMERCE_LEARN = [
  {
    topic: "Channels of Distribution",
    content: "Producer → Consumer (direct). Producer → Retailer → Consumer. Producer → Wholesaler → Retailer → Consumer. Wholesalers provide: bulk breaking, warehousing, credit, transport. Retailers provide: convenience, after-sales service, display. E-commerce shortens the chain.",
  },
  {
    topic: "Banking",
    content: "Commercial banks: accept deposits, give loans, facilitate payments. Central bank: monetary policy, lender of last resort, issues currency. Types of accounts: current (cheque-based), savings (interest-bearing), fixed deposit. Instruments: cheque, draft, standing order, direct debit.",
  },
  {
    topic: "Insurance",
    content: "Principles: Insurable interest (you must stand to lose), Utmost good faith (full disclosure), Indemnity (restore, not profit), Subrogation (insurer takes over rights after paying), Contribution (share between insurers). Types: life, fire, marine, motor, liability.",
  },
  {
    topic: "Transportation",
    content: "Road: flexible, door-to-door, but costly for bulk. Rail: heavy goods, cheaper per tonne-km, fixed routes. Sea: cheapest for bulk/international, slow. Air: fastest, expensive, perishables/valuables. Pipeline: continuous, ideal for oil/gas. Choice depends on: cost, speed, nature of goods, distance.",
  },
  {
    topic: "Home & Foreign Trade",
    content: "Home trade: within a country (wholesale + retail). Foreign trade: between countries. Imports: goods bought from abroad. Exports: goods sold abroad. Balance of trade: exports – imports. Favourable when exports > imports. Barriers: tariffs, quotas, embargoes, licences. ECOWAS promotes intra-African trade.",
  },
];
